import LocalStorageService from "../services/localstorage-service";

export class Settings {
    static useOfflineMode : boolean = LocalStorageService.getOfflineMode();
    static sideNav : SideNavSettings = LocalStorageService.getSidenavSettings();
    private static collapsedViews = {}; 

    static setUseOfflineMode(state: boolean) {
        this.useOfflineMode = state;
        LocalStorageService.setOfflineMode(this.useOfflineMode);
    }

    static setNavbarStatic(state: boolean) {
        this.sideNav.isStatic = state;
        LocalStorageService.setSidenavSettings(this.sideNav);
    }

    static setNavbarShowGraph(state: boolean) {
        this.sideNav.showGraph = state;
        LocalStorageService.setSidenavSettings(this.sideNav);
    }

    static setNavbarShowIdeaBox(state: boolean) {
        this.sideNav.showIdeabox = state;
        LocalStorageService.setSidenavSettings(this.sideNav);
    }

    static setTableGlyphSketching(state: boolean) {
        this.sideNav.tableGlyphSketching = state;
        LocalStorageService.setSidenavSettings(this.sideNav);
    }

    static setHideGlyphs(state: boolean) {
        this.sideNav.hideGlyphs = state;
        LocalStorageService.setSidenavSettings(this.sideNav);
    }

    static collapseView(id: string, state: boolean) {
        //@ts-ignore
        this.collapsedViews[id] = state;
    }

    static isCollapsedView(id: string) : boolean {
        //@ts-ignore
        return !!this.collapsedViews[id]
    }
}

export interface SideNavSettings{
    isStatic: boolean;
    showGraph: boolean;
    showIdeabox: boolean;
    tableGlyphSketching: boolean;
    hideGlyphs: boolean;
}